export const VIEW_ENTER = 'withOmni/VIEW_ENTER';

export const viewEnter = () => ({
  type: VIEW_ENTER
});
